<div class="modal-header bg-white">
  <h5 class="modal-title" id="staticBackdropLabel" *ngIf="entity" i18n="@@TransactionDialogHeaderTitle">
    Details zum Ladevorgang {{ entity.transactionId }}
  </h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>
<div class="modal-body">
  <app-details-transaction #detailsTransaction (entityLoadedEvent)="onEntityLoadedEvent($event)"></app-details-transaction>
  <div class="container-fluid">
    <div class="row">
      <div class="col-4 text-center rounded-1 pt-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-zap big-icons"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
      </div>
      <div class="col-4 text-center rounded-1 pt-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-battery-charging big-icons"><path d="M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"></path><line x1="23" y1="13" x2="23" y2="11"></line><polyline points="11 6 7 12 13 12 9 18"></polyline></svg>
      </div>
      <div class="col-4 text-center rounded-1 pt-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-zap-off big-icons"><polyline points="12.41 6.75 13 2 10.57 4.92"></polyline><polyline points="18.57 12.91 21 10 15.66 10"></polyline><polyline points="8 8 3 14 12 14 11 22 16 16"></polyline><line x1="1" y1="1" x2="23" y2="23"></line></svg>
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-center my-2">{{ entity.startTimestamp | date: 'short':'+0000'}}</div>
      <div class="col-4 text-center my-2">{{ entity.meterAmount | kwh }} kWh</div>
      <div class="col-4 text-center my-2">{{ entity.stopTimestamp | date: 'short':'+0000' }} </div>
    </div>
  </div>
  <div class="container-fluid border-top">
    <div class="row">
      <div class="col-12 text-center h5 pt-3">
        {{ entity.successMessage }}
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" id="cancel" class="btn btn-yellow" data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CancelButton">Schließen</button>
  <button type="button" id="download_sighedmtervalues"  class="btn btn-yellow" (click)="downloadSignedMeterValues()" i18n="@@DownloadSignedMeterValues" [disabled]="!fileExists">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
    Signierte Daten herunterladen
  </button>
</div>
